import { jobTitlesList } from './constants';

// get job titles based on organization type
export const getJobTitles = (
  orgType:
    | 'edu_organization'
    | 'edu_institution'
    | 'skillspace_organization'
) => jobTitlesList[orgType];
